'use strict';

/*globals Waypoint */
require('waypoints');

var loadDisqusComments = function() {
	var disqus_shortname = 'todaysgolfer';
	var waypoint = new Waypoint({
		element: document.getElementById('disqus_thread'),
		handler: function() {
			var dsq = document.createElement('script');
			dsq.async = true;
			dsq.src = 'http://' + disqus_shortname + '.disqus.com/embed.js';
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
			waypoint.destroy();
		},
		offset: '120%'
	});
};

module.exports = {
	init: function () {
		loadDisqusComments();
	}
};